import request from '@/utils/request'

export function getAgentLevelList() {
  return request({
    url: '/api/v1/admin/agent/get_agent_level',
    method: 'post',
  })
}

export function addAgentLevel(data) {
  return request({
    url: '/api/v1/admin/agent/add_agent_level',
    method: 'post',
    data,
  })
}

export function editAgentLevel(data) {
  return request({
    url: '/api/v1/admin/agent/update_agent_level',
    method: 'post',
    data,
  })
}

export function getAgentCountList(data) {
  return request({
    url: '/api/v1/admin/agent/get_official_agent_player',
    method: 'post',
    data,
  })
}

export function getAgentList(data) {
  return request({
    url: '/api/v1/admin/agent/list',
    method: 'post',
    data,
  })
}

export function addAgent(data) {
  return request({
    url: '/api/v1/admin/agent/add',
    method: 'post',
    data,
  })
}

export function editAgent(data) {
  return request({
    url: '/api/v1/admin/agent/update',
    method: 'post',
    data,
  })
}

export function getAgentModeSetting() {
  return request({
    url: '/api/v1/admin/agent/get_agent_model',
    method: 'post',
  })
}

export function saveAgentModeSetting(data) {
  return request({
    url: '/api/v1/admin/agent/save_agent_model',
    method: 'post',
    data,
  })
}

export function getInviteUserList(data) {
  return request({
    url: '/api/v1/admin/agent/get_normal_agent_player',
    method: 'post',
    data,
  })
}
